import React, { useState } from 'react';
/*
import { 
  Book, 
  Youtube, 
  Github, 
  MessageSquare,
  Newspaper,
  ExternalLink,
  GraduationCap,
  Users,
  ChevronDown,
  ChevronRight,
  Globe
} from 'lucide-react';
 */

import { 
  ChevronDown,
  ChevronRight, 
  BookOpen, 
  GraduationCap,
  Code,
  FileText,
  Youtube,
  Book,
  Search,
  MessageSquare,
  Newspaper,
  ExternalLink,
  Users,
  Globe,
  Layers
} from 'lucide-react';

const ResourceSection = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <section className="mb-8 bg-white rounded-lg shadow-sm overflow-hidden">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-8 py-6 text-left bg-white hover:bg-gray-50 flex items-center justify-between"
      >
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        {isOpen ? <ChevronDown className="h-6 w-6" /> : <ChevronRight className="h-6 w-6" />}
      </button>
      {isOpen && (
        <div className="px-8 pb-8">
          {children}
        </div>
      )}
    </section>
  );
};

const ResourcesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      {/*
      <div className="bg-gradient-to-r from-blue-900 to-indigo-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <h1 className="text-4xl font-bold mb-6 text-center">
            Quantum Computing Learning Resources
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto text-center">
            Welcome to our comprehensive collection of quantum computing resources. This repository aims to provide a curated list of free resources to help you learn about quantum computing. Whether you are a beginner or an experienced researcher, these resources can help you dive into the fascinating world of quantum computing.
          </p>
        </div>
      </div>
       */}
       <div className="relative overflow-hidden bg-gradient-to-r from-blue-900 to-indigo-900">
      <div className="relative pt-16 pb-20 sm:pt-24 sm:pb-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl"> */}
            <h1 className="text-4xl font-bold mb-6 text-white">
              <span className="block">Master Quantum</span>
              <span className="block text-blue-400">Computing</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-300">
              Access a curated collection of quantum computing resources, from foundational concepts to advanced applications. Learn from leading institutions and experts in the field.
            </p>
          {/*
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <button className="rounded-md bg-blue-500 px-6 py-3 text-white hover:bg-blue-600 flex items-center justify-center">
                Start Learning
                <ChevronRight className="ml-2 h-4 w-4" />
              </button>
              <button className="rounded-md border border-white px-6 py-3 text-white hover:bg-white/10 flex items-center justify-center">
                Contribute Resources
                <FileText className="ml-2 h-4 w-4" />
              </button>
            </div>
           */}

            {/* Resource Search */}
            {/*
            <div className="mt-12 bg-white/10 rounded-lg p-6 max-w-3xl mx-auto backdrop-blur-sm">
              <div className="relative max-w-xl mx-auto">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <input
                  type="text"
                  placeholder="Search quantum computing resources..."
                  className="w-full pl-10 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
              */}

            {/* Resource Categories */}
            {/*
            <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-3">
              <div className="flex flex-col items-center">
                <GraduationCap className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Learning Paths</h3>
                <p className="mt-2 text-gray-300">Structured courses and tutorials</p>
              </div>
              <div className="flex flex-col items-center">
                <Code className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Development Tools</h3>
                <p className="mt-2 text-gray-300">SDKs and programming resources</p>
              </div>
              <div className="flex flex-col items-center">
                <BookOpen className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Documentation</h3>
                <p className="mt-2 text-gray-300">Guides and reference materials</p>
              </div>
            </div>
            */}

            {/* Quick Access */}
            {/*
            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <Book className="h-4 w-4" />
                <span>Courses</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <Youtube className="h-4 w-4" />
                <span>Video Tutorials</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <Layers className="h-4 w-4" />
                <span>Libraries</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <FileText className="h-4 w-4" />
                <span>Research Papers</span>
              </a>
            </div>
            */}

            {/* Resource Stats */}
            {/*
            <div className="mt-12 flex justify-center gap-8 text-center">
              <div>
                <div className="text-blue-400 font-bold text-2xl">500+</div>
                <div className="text-gray-300 text-sm">Learning Resources</div>
              </div>
              <div>
                <div className="text-blue-400 font-bold text-2xl">50+</div>
                <div className="text-gray-300 text-sm">Expert Contributors</div>
              </div>
              <div>
                <div className="text-blue-400 font-bold text-2xl">24/7</div>
                <div className="text-gray-300 text-sm">Resource Access</div>
              </div>
            </div>
            */}
          </div>
        </div>
      </div>
    </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Qiskit Section */}
        <ResourceSection title="Qiskit Resources" defaultOpen={true}>
          <div className="space-y-6">
            <p className="text-gray-600">
              Quantum computing leverages principles from quantum mechanics to solve complex problems more efficiently than classical computers. It involves concepts like superposition, entanglement, and quantum gates.
            </p>
            
            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Courses</h3>
                <ul className="space-y-4">
                  <li className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-blue-600">Understanding quantum information and computation</h4>
                    <p className="text-gray-600">This free course covers quantum information at a detailed mathematical level. Join John Watrous as you explore quantum information, quantum algorithms, and how to understand and mitigate noise.</p>
                  </li>
                  <li className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-blue-600">Introduction course</h4>
                    <p className="text-gray-600">Not sure where to start? This path is for you. This introduction is aimed at audiences from all backgrounds.</p>
                  </li>
                  {/* Add all other courses */}
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Chapters</h3>
                <ul className="space-y-4">
                  <li className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-blue-600">Prerequisites</h4>
                    <p className="text-gray-600">Learn about the software used to write the Qiskit textbook (Python and Jupyter Notebooks), and set up your environment.</p>
                  </li>
                  {/* Add all other chapters */}
                </ul>
              </div>
            </div>
          </div>
        </ResourceSection>

        {/* Pennylane Section */}
        <ResourceSection title="Pennylane Resources">
          <div className="space-y-6">
            <p className="text-gray-600">Pennylane has some amazing demos and learning resources</p>
            
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Learn quantum programming</h3>
              <ul className="space-y-4">
                <li className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-medium text-blue-600">Quantum Computing</h4>
                  <p className="text-gray-600">Quantum computing is a research area that extends the set of physical laws classical computers operate on by accessing quantum aspects of the physical world.</p>
                </li>
                {/* Add other sections */}
              </ul>
            </div>
            
            {/* Add demonstrations and tutorials */}
          </div>
        </ResourceSection>

        {/* OpenHPI Section */}
        <ResourceSection title="Open HPI">
          <div className="space-y-6">
            <p className="text-gray-600">Video lectures can provide an interactive way to learn quantum computing concepts. Here are some free video lecture series:</p>
            
            <ul className="space-y-4">
              <li className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-blue-600">Introduction to Quantum Computing with Qiskit (with IBM Quantum)</h4>
                <p className="text-gray-600">Learn how to use Qiskit for working with quantum computers.</p>
              </li>
              {/* Add other courses */}
            </ul>
          </div>
        </ResourceSection>

        {/* Continue with ALL other sections */}
        <ResourceSection title="IQM">
          {/* IQM content */}
        </ResourceSection>

        <ResourceSection title="YouTube Resources">
          {/* Complete YouTube content */}
        </ResourceSection>

        <ResourceSection title="MIT Courses">
          {/* MIT content */}
        </ResourceSection>

        <ResourceSection title="TU Delft Courses">
          {/* TU Delft content */}
        </ResourceSection>

        <ResourceSection title="NPTEL Resources">
          {/* NPTEL content */}
        </ResourceSection>

        <ResourceSection title="Individual Contributors">
          {/* Individual contributors content */}
        </ResourceSection>

        <ResourceSection title="GitHub Resources">
          {/* GitHub content */}
        </ResourceSection>

        <ResourceSection title="Community Forums">
          {/* Community forums content */}
        </ResourceSection>

        <ResourceSection title="Blogs and Newsletters">
          {/* Blogs and newsletters content */}
        </ResourceSection>
      </div>
    </div>
  );
};

export default ResourcesPage;